<script>
/**
 * @component HealthScoreBadge
 * @description Chip visual con el score de una HealthConversation (X/10) y
 *              el semáforo (verde/amarillo/rojo). Reusa colores de AlertBadge.
 *              Si score es null (paciente no respondió), muestra "—".
 * @example <HealthScoreBadge :score="7" semaphore="yellow" />
 */
export default {
  name: "HealthScoreBadge",

  props: {
    /**
     * @description Score 1-10. null si patient_silent / error.
     */
    score: {
      type: Number,
      default: null,
    },
    /**
     * @description Semáforo resuelto desde score + thresholds.
     */
    semaphore: {
      type: String,
      default: null,
      validator: (v) => v === null || ["green", "yellow", "red"].includes(v),
    },
    /**
     * @description Tamaño visual del chip: 'sm' | 'md' | 'lg'.
     */
    size: {
      type: String,
      default: "md",
      validator: (v) => ["sm", "md", "lg"].includes(v),
    },
  },

  computed: {
    label() {
      if (this.score == null) return "—";
      return `${this.score}/10`;
    },
    colorClass() {
      return this.semaphore || "no-data";
    },
  },
};
</script>

<template lang="pug">
  span.health-score-badge(:class="[colorClass, `size-${size}`]")
    span.health-score-badge__dot
    span.health-score-badge__label {{ label }}
</template>

<style lang="scss" scoped>
.health-score-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 16px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 600;
  padding: 4px 10px;
  border: 1px solid;

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: currentColor;
  }
  &__label {
    font-variant-numeric: tabular-nums;
  }

  &.size-sm {
    font-size: 11px;
    padding: 2px 8px;
  }
  &.size-md {
    font-size: 13px;
  }
  &.size-lg {
    font-size: 18px;
    padding: 8px 16px;
  }

  &.green {
    color: #1f8a4c;
    border-color: #b9e3c7;
    background: #ebf7f0;
  }
  &.yellow {
    color: #b07c0a;
    border-color: #f1d899;
    background: #fbf3e0;
  }
  &.red {
    color: #b3261e;
    border-color: #efb4b0;
    background: #fbe9e7;
  }
  &.no-data {
    color: #6b7280;
    border-color: #d1d5db;
    background: #f3f4f6;
  }
}
</style>
